(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/elevation', ['exports', '@angular/core'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.elevation = {}), global.ng.core));
}(this, (function (exports, core) { 'use strict';

    var MdcElevation = /** @class */ (function () {
        function MdcElevation(elementRef) {
            this.elementRef = elementRef;
            this.mdcElevation = 0;
        }
        MdcElevation.prototype.ngOnChanges = function (changes) {
            var change = changes['mdcElevation'];
            if (change.currentValue < 0 || change.currentValue > 24) {
                throw new Error("Valid mdc-elevation values are 0 through 24");
            }
            if (!change.isFirstChange()) {
                this.elementRef.nativeElement.classList.remove("mdc-elevation--z" + change.previousValue);
            }
            this.elementRef.nativeElement.classList.add("mdc-elevation--z" + change.currentValue);
        };
        MdcElevation.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcElevation]',
                        exportAs: 'mdcElevation'
                    },] }
        ];
        /** @nocollapse */
        MdcElevation.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcElevation.propDecorators = {
            mdcElevation: [{ type: core.Input }]
        };
        return MdcElevation;
    }());

    var MdcElevationModule = /** @class */ (function () {
        function MdcElevationModule() {
        }
        MdcElevationModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [MdcElevation],
                        declarations: [MdcElevation]
                    },] }
        ];
        return MdcElevationModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcElevation = MdcElevation;
    exports.MdcElevationModule = MdcElevationModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-elevation.umd.js.map
